import { motion } from "framer-motion";

const LEADERS = [
  {
    name: "Bruttisundar Giri",
    role: "Promoter & Founder",
    bio: "10+ years across reputed companies and PSUs in design engineering, project management and new technology transfer.",
    image: "/assets/leadership-bruttisundar.jpg",
  },
  {
    name: "Birendra Nath Giri",
    role: "Co-Founder",
    bio: "30+ years in government organisations. Ex-government employee bringing deep institutional and compliance expertise.",
    image: "/assets/leadership-birendra.png",
  },
  {
    name: "Arpita Beck",
    role: "Co-Founder",
    bio: "8 years of experience in Business Development and Tender Management, driving growth and client partnerships.",
    image: "/assets/leadership-arpita-new.png",
  },
];

export default function Leadership() {
  return (
    <section id="leadership" className="py-28 lg:py-40 border-t border-white/10" data-testid="leadership-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-mono-accent text-xs tracking-[0.35em] uppercase text-neon mb-6"
        >
          Leadership
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight mb-20"
          data-testid="leadership-heading"
        >
          The people <span className="text-outline">behind the group.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {LEADERS.map((leader, i) => (
            <motion.article
              key={leader.name}
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="group card-glow img-zoom spotlight-card border border-white/10 bg-navy-800/40"
              data-testid={`leader-card-${i}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={leader.image}
                  alt={leader.name}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent" />
              </div>
              <div className="p-7">
                <h3 className="font-display text-xl lg:text-2xl font-bold tracking-tight">{leader.name}</h3>
                <p className="font-mono-accent text-[11px] tracking-[0.2em] uppercase text-electric mt-2 group-hover:text-neon transition-colors duration-300">
                  {leader.role}
                </p>
                <p className="text-sm text-slate-400 leading-relaxed mt-4">{leader.bio}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
